import { createResourceStore } from '@next-qr/lib-ui/store';
import { userApi } from './api';

export const useUserStore = createResourceStore(userApi);
